var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VpanelEcommAddModifyModal',{attrs:{"modal-icon":"fas fa-ruler","section-name":"Unit of Measure","form-id":"product-uom-add-form","namespace":"productUom/addModify","form-name":"vpanel-add-product-uom-form"}})}
var staticRenderFns = []

export { render, staticRenderFns }